import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../api/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const createUser = async ({ name, email, role_ids = [] }) => {
  const { data } = await authApiClient.post('/users', { name, email, role_ids });
  return data;
};

export const useCreateUserHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: data?.message || 'User invited successfully',
          severity: 'success',
        }),
      );
      onSuccess?.(data);
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError ? error.response?.data?.errors?.message || error.message : 'Failed to invite user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
